import { useState } from 'react'

import eventTrack from 'schemas/eventTrack'

import { FiCheck, FiX } from 'react-icons/fi'

const Track = ( {
  value = {
    name: '',
    at: '',
    level: '',
    head: '',
    tail: ''
  },
  update = console.log
} ) => {
  const [ model, setModel ] = useState( { ...value } )

  const handleChange = ( e ) => {
    const { name, value } = e.target

    setModel( { ...model, [ name ]: value } )
  }

  const cancel = () => {
    console.log( 'cancel' )
  }

  const save = () => {
    console.log( { save: model } )

    const m = eventTrack.cast( model )

    console.log( { m } )

    eventTrack.validate( m )
      .then( () => {
        console.log( 'valid' )
      } )
      .catch( err => {
        console.log( err )
      } )
  }

  return <div className="hs gap-2x">
    <div className="bar">
      <h1>{ model.name || 'unnamed track' }</h1>

      <button
        type="button"
        onClick={ cancel }
      >
        <FiX />
      </button>

      <button
        type="button"
        onClick={ save }
      >
        <FiCheck />
      </button>
    </div>

    <div className="form-field">
      <label>name</label>

      <div className="form-control">
        <input
          name="name"
          value={ model.name }
          onChange={ handleChange }
          size={ 1 }
          placeholder="name"
          required
        />
      </div>
    </div>

    <div className="vs gap-2x">
      <div className="one form-field">
        <label>at</label>

        <div className="form-control">
          <input
            type="datetime-local"
            name="at"
            value={ model.at }
            onChange={ handleChange }
            size={ 1 }
            required
          />
        </div>
      </div>

      <div className="one form-field">
        <label>level</label>

        <div className="form-control">
          <select
            name="level"
            value={ model.level }
            onChange={ handleChange }
            size={ 1 }
            required
          >
            <option value="" disabled>level</option>
            <option>low</option>
            <option>middle</option>
            <option>high</option>
          </select>
        </div>
      </div>

    </div>

    <div className="vs gap-2x">
      <div className="one form-field">
        <label>head</label>

        <div className="form-control">
          <select
            name="head"
            value={ model.head }
            onChange={ handleChange }
            size={ 1 }
          >
            <option value="" disabled>head</option>
            <option value={ 156355 }>octopolar</option>
            <option value={ 125322 }>ca0smos</option>
          </select>
        </div>
      </div>

      <div className="one form-field">
        <label>tail</label>

        <div className="form-control">
          <select
            name="tail"
            value={ model.tail }
            onChange={ handleChange }
            size={ 1 }
          >
            <option value="" disabled>tail</option>
            <option value={ 156355 }>octopolar</option>
            <option value={ 125322 }>ca0smos</option>
          </select>
        </div>
      </div>

    </div>

  </div>
}

export default Track
